import React, { useEffect, useState, useCallback, useRef } from "react";
import {
  BrowserRouter as Router,
  useNavigate,
  useLocation,
} from "react-router-dom";
import { Chip } from "@mui/material";
import Slide from "@mui/material/Slide";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Tooltip from "@mui/material/Tooltip";
import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import CustomDateTimePicker from '../../components/CustomDateTimePicker';
import CustomerTimePicker from '../../components/CustomTimePicker'
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { Card, Divider, Select } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import { HighlightOff, InfoRounded, Done } from "@material-ui/icons";

import {
  Typography,
  Box,
  TextField,
  InputAdornment,
  Button,
  IconButton,
  Grid,
  OutlinedInput,
  Checkbox,
  ListItemText,
} from "@material-ui/core";
import clsx from 'clsx';
import CancelIcon from "@mui/icons-material/Cancel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import StopIcon from "@material-ui/icons/Stop";
import CloseIcon from "@material-ui/icons/Close";
import PaymentIcon from "@material-ui/icons/Payment";
import PhoneIcon from "@material-ui/icons/Phone";
import axios from "axios";
import {
  usePlacesWidget,
} from "react-google-autocomplete";
import { getUserId } from "../../Utils/Common";
import moment from "moment";
import MaterialAuto from "./MaterialAuto";
import MaterialAuto1 from "./MaterialAuto1";
import Geocode from "react-geocode";
import { Skeleton } from "@material-ui/lab";
import { useCompanyTheme } from '../../context/CompanyContext';
import { backendUrl, anonKey, adminBackend } from '../../config';
import { bookingEnabled } from '../../config';
import { countries } from '../../Utils/countries';
import { vehicleArray, TaxiModelArray, getDriverByModel } from '../../Utils/vehicles';
import { useStyles } from '../../styles/booking-styles';

export const VehicleDisplay = ({
  setDetailViewIndex,
  fareDetails,
  fareDetails1,
  modelList,
  driverDetails,
  setSelectedModel,
  setDriverMarkerData,
  driverETA,
  bookType,
  activeIndex,
  setActiveIndex,
  pickUp,
  selectedModel,
  drop,
  setApproxTripFare,
  modelCat,
  setModelCat,
  baseFare,
  setBaseFare,
  planBaseFare,
  setPlanBaseFare, setTwoWayBaseFare, splitDetails, companyId,
  companyTheme

}) => {


  const classes = useStyles({ companyTheme });

  // const { companyTheme } = useCompanyTheme();


  const activeClick = (e, index) => {
    let model = fareDetails[index];

    setModelCat(TaxiModelArray[index].toString());
    setActiveIndex(index);
    model.image = `/static/images/${vehicleArray[index].vehicleType}.png`;

    setSelectedModel(model);
    setBaseFare(model.fare);
    setPlanBaseFare(model.fare);
    setTwoWayBaseFare(model.fare);
    setApproxTripFare(model.fare);
  };

  return (
    // <Box style={{ flexGrow: 1, marginTop: "12px" }}>
    //   <Grid container spacing={1} alignItems="center">
    <Box sx={{ marginTop: "8px", backgroundColor: "#f9fafb" }}>
      <Grid container spacing={0} alignItems="center">

        <Grid item xs={4} className={classes.formContent}>
          <Box>
            <Typography
              style={{ fontSize: "14px", fontWeight: "400" }}
              variaint="subtitle2"
            >
              Car Type:
            </Typography>
          </Box>
        </Grid>

        {fareDetails.length > 0 ? (
          <Grid
            container
            item
            md={8}
            xs={4}
            flexDirection="row"
            className={classes.formContent}

          >
            <Box
              style={{
                display: "flex",
                width: "100%",
                gap: "6px",
                justifyContent: "flex-start",
                // alignItems: "flex-start",
                paddingBottom: "10px",
                overflowX: "auto",
                WebkitOverflowScrolling: "touch",
                scrollbarWidth: 'none',
              }}
            >
              {fareDetails.map((data, index) =>

                data.model_name ? (
                  <Grid
                    item
                    justifyContent="flex-start"
                    key={`fare-model-${data._id || index}`}
                  >
                    <Box
                      style={{
                        height: "90px",
                        width: "80px",
                        flexShrink: 0,
                        flexDirection: "column",
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "10px",

                      }}
                      boxShadow={2}
                      className={clsx(classes.searchResult, {
                        [classes.activeBox]: index === activeIndex,
                        [classes.cardPaperInvertBackground]: index !== activeIndex,
                      })}
                      onClick={(e) => activeClick(e, index)}
                    >
                      <Box
                        style={{
                          flexGrow: 1,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          paddingBottom: "2px",
                        }}
                      >
                        {vehicleArray &&
                          vehicleArray[index] &&
                          vehicleArray[index].vehicleType ? (
                          <img
                            src={
                              index === activeIndex && selectedModel?.image
                                ? selectedModel.image
                                : data?.beforeSelect
                                  ? data.beforeSelect
                                  : `/static/images/${vehicleArray[index]?.vehicleType}.png`
                            }
                            alt={data.model_name || "vehicle"}
                            style={{
                              maxWidth: "100%",
                              height: "auto",
                              width: "auto",
                              marginBottom: data.model_name === "AE EXPRESS PICKUP" ? "-15px" : ""
                            }}
                          />
                        ) : (
                          <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                          </div>
                        )}
                      </Box>

                      <Box
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          textAlign: "center",
                        }}
                      >
                        {data.model_name && (
                          <Typography
                            variant="subtitle2"
                            style={{ fontSize: "11px", fontWeight: "400", lineHeight: "1.1" }}
                          >
                            {data.model_name}
                          </Typography>
                        )}
                        <Box display="flex" alignItems="center" justifyContent="center">
                          <Typography
                            variant="subtitle2"
                            style={{
                              fontSize: "11px",
                              fontWeight: "400",
                            }}
                          >
                            {pickUp.address !== "" && drop.address !== ""
                              ? bookType === 0
                                ? data.fare
                                  ? "AED " + data.fare
                                  : ""
                                : bookType === 1
                                  ? data.full_day
                                    ? "AED " + data.full_day
                                    : ""
                                  : bookType === 2
                                    ? data.half_day
                                      ? "AED " + data.half_day
                                      : ""
                                    : bookType === 3
                                      ? data.fare
                                        ? "AED " + data.fare
                                        : ""
                                      : ""
                              : ""}
                          </Typography>
                        </Box>
                        <Typography variant="subtitle2" style={{ color: "#606060", fontSize: "9px" }}>
                          {index == activeIndex &&
                            driverETA > 0 &&
                            getDriverByModel(driverDetails, data.modelId).length > 0
                            ? "ETA: " + (driverETA / 60).toFixed(2) + " mins"
                            : ""}
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>
                ) : (
                  ""
                )
              )}
            </Box>

            {modelCat && modelCat.split(",").filter(Boolean).length > 0 && (
              <Box
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "4px",
                  marginTop: "10px",
                  color: companyTheme?.primaryColorCode,
                  minHeight: "25px",
                  alignItems: "flex-start",
                  overflow: "hidden",
                  width: "100%",
                }}
              >
                {modelCat.split(",").map((model, index) =>
                  model.trim() !== "" ? (
                    <Chip
                      key={`chip-${index}`}
                      label={model.trim()}
                      color="primary"
                      variant="outlined"
                      sx={{
                        borderColor: companyTheme?.primaryColorCode,
                        color: companyTheme?.primaryColorCode,
                        fontSize: "11px",
                        height: "25px",
                        width: "fit-content",
                        minWidth: "60px",
                        flexShrink: 0,
                        "& .MuiChip-label": {
                          fontWeight: "bold",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          paddingLeft: "6px",
                          paddingRight: "6px",
                        },
                      }}
                    />
                  ) : (
                    ""
                  )
                )}
              </Box>
            )}
          </Grid>
        ) : (
          (modelList.length > 0 || (modelCat && modelCat.split(",").filter(Boolean).length > 0)) && (
            <Grid
              container
              item
              xs={8}
              flexDirection="row"
              className={classes.formContent}
            >
              <Box
                style={{
                  display: "flex",
                  width: "100%",
                  gap: "6px",
                  alignItems: "flex-start",
                  paddingBottom: "10px",
                }}
              >
                {modelList.map((data, index) =>
                  data.modelName ? (
                    <Grid
                      item
                      justifyContent="flex-start"
                      key={`model-list-model-${data.modelId || index}`}
                    >
                      <Box
                        style={{
                          height: "90px",
                          width: "80px",
                          flexShrink: 0,
                          flexDirection: "column",
                          display: "flex",
                          justifyContent: "space-between",
                          padding: "10px",
                        }}
                        boxShadow={2}
                        className={`${classes.searchResult} ${activeIndex === ""
                          ? classes.cardPaperBackground
                          : index !== activeIndex
                            ? classes.cardPaperInvertBackground
                            : index === activeIndex
                              ? classes.activeBox
                              : ""
                          }`}
                        onClick={(e) => activeClick(e, index)}
                      >
                        {/* Image Section (Placeholder as per previous versions) */}
                        <Box
                          style={{
                            flexGrow: 1,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            paddingBottom: "2px",
                          }}
                        >
                        </Box>

                        <Box
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            textAlign: "center",

                          }}
                        >
                          {data.modelName && (
                            <Typography
                              variant="subtitle2"
                              style={{ fontSize: "11px", fontWeight: "400", lineHeight: "1.1" }}
                            >
                              {data.modelName}
                            </Typography>
                          )}
                          <Box display="flex" alignItems="center" justifyContent="center">
                            <Typography
                              variant="subtitle2"
                              style={{
                                fontSize: "11px",
                                fontWeight: "400",
                              }}
                            >
                              {pickUp.address !== "" && drop.address !== ""
                                ? bookType === 0
                                  ? data.fare
                                    ? "AED " + data.fare
                                    : ""
                                  : bookType === 1
                                    ? data.full_day
                                      ? "AED " + data.full_day
                                      : ""
                                    : bookType === 2
                                      ? data.half_day
                                        ? "AED " + data.half_day
                                        : ""
                                      : bookType === 3
                                        ? data.fare
                                          ? "AED " + data.fare
                                          : ""
                                        : ""
                                : ""}
                            </Typography>
                          </Box>
                          <Typography variant="subtitle2" style={{ color: "#606060", fontSize: "9px" }}>
                            {index == activeIndex &&
                              driverETA > 0 &&
                              getDriverByModel(driverDetails, data.modelId).length > 0
                              ? "ETA: " + (driverETA / 60).toFixed(2) + " mins"
                              : ""}
                          </Typography>
                        </Box>
                      </Box>
                    </Grid>
                  ) : (
                    ""
                  )
                )}
              </Box>

              {/* Chips section for modelCat - IN A SEPARATE ROW BELOW THE MODELS */}
              {modelCat && modelCat.split(",").filter(Boolean).length > 0 && (
                <Box
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "4px",
                    marginTop: "10px",
                    color: companyTheme?.primaryColorCode,
                    minHeight: "25px",
                    alignItems: "flex-start",
                    overflow: "hidden",
                    width: "100%",
                  }}
                >
                  {modelCat.split(",").map((model, index) =>
                    model.trim() !== "" ? (
                      <Chip
                        key={`chip-${index}`}
                        label={model.trim()}
                        color="primary"
                        variant="outlined"
                        sx={{
                          borderColor: companyTheme?.primaryColorCode,
                          color: companyTheme?.primaryColorCode,
                          fontSize: "11px",
                          height: "25px",
                          width: "fit-content",
                          minWidth: "60px",
                          flexShrink: 0,
                          "& .MuiChip-label": {
                            fontWeight: "bold",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            paddingLeft: "6px",
                            paddingRight: "6px",
                          },
                        }}
                      />
                    ) : (
                      ""
                    )
                  )}
                </Box>
              )}
            </Grid>
          )
        )}

      </Grid>
    </Box>
  );
};